import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import { OrderedMap, Seq } from 'immutable';

import Brand from 'models/brand';

import CancelComponent from 'components/bookings/cancel';

import cancelBooking from 'action-creators/bookings/cancel-booking';
import cleanupCancelBookingState from 'action-creators/bookings/cleanup-cancel-booking-state';

const propTypes = {
  bookingId: PropTypes.number.isRequired,
  bookings: PropTypes.instanceOf(Seq.Keyed).isRequired,
  locations: PropTypes.instanceOf(OrderedMap).isRequired,
  cancelBooking: PropTypes.func.isRequired,
  cleanupCancelBookingState: PropTypes.func.isRequired,
  brand: PropTypes.instanceOf(Brand).isRequired,
  locale: PropTypes.string.isRequired,
};

class BookingCancel extends Component {
  componentWillUnmount() {
    this.props.cleanupCancelBookingState();
  }

  render() {
    const { bookings, bookingId } = this.props;
    const booking = bookings.get(bookingId);
    const { cancellable = false } = booking || {};

    return (
      <div className="generic-page account-settings">
        <div className={`generic-body cancellation-container ${cancellable ? '' : 'expired'}`}>
          <div className="slim-header primary-gradient-background hidden-xs">
            <div className="container">
              <div className="row">
                <div className="slim-header-title col-lg-3 col-sm-4">
                  <FormattedMessage id="cancel.cancel-parking" defaultMessage="Cancel Parking" />
                </div>
              </div>
            </div>
          </div>
          <div className="container floating-container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1">
                <CancelComponent {...this.props} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let { location: routerLocation } = state.router;
  if (!routerLocation) {
    ({ routerLocation } = ownProps);
  }

  const {
    user,
  } = state.account;

  const {
    brand,
  } = state.brand;

  const { locale } = state.app;

  const {
    bookings,
    locations,
    events,
    selectedParkingPassIds,
  } = state.bookings;

  let { bookingId } = ownProps;
  if (!bookingId) {
    bookingId = selectedParkingPassIds.first();
  }

  return {
    user,
    bookings,
    bookingId,
    locations,
    events,
    routerLocation,
    brand,
    locale,
  };
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    cancelBooking,
    cleanupCancelBookingState,
  }, dispatch)
);

BookingCancel.propTypes = propTypes;
export default connect(mapStateToProps, mapDispatchToProps)(BookingCancel);
